import React, { useState, Component } from 'react';
import { useLanguage } from './LanguageContext';
import { CheckCircle2, Lock, Phone, Mail, MapPin } from 'lucide-react';
export const ContactForm = () => {
  const {
    t
  } = useLanguage();
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [service, setService] = useState('');
  const [date, setDate] = useState('');
  const trustItems = [t('contact.t1'), t('contact.t2'), t('contact.t3'), t('contact.t4')];
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const message = `Hi! I'd like a Free Estimate 🧹
👤 Name: ${name}
📞 Phone: ${phone}
🧺 Service: ${service}
📅 Date: ${date}

Please contact me!`;
    const encoded = encodeURIComponent(message);
    const whatsappNumber = '17866603720';
    window.open(`https://wa.me/${whatsappNumber}?text=${encoded}`, '_blank');
  };
  return <section id="contact" className="bg-brand-marble py-16 md:py-20" data-id="element-44">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-45">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-12 items-start" data-id="element-46">
          {/* Left Side */}
          <div data-id="element-47">
            <h2 className="font-montserrat font-extrabold text-[26px] md:text-[42px] text-brand-navy leading-[1.3] md:leading-tight mb-6 md:mb-8 text-center md:text-left" data-id="element-48">
              {t('contact.title1')}
              <br data-id="element-49" />
              <span className="text-brand-gold" data-id="element-50">{t('contact.title2')}</span>
            </h2>

            <div className="space-y-3 md:space-y-4 mb-8 md:mb-10" data-id="element-51">
              {trustItems.map((item, index) => <div key={index} className="flex items-center gap-3" data-id="element-52">
                  <CheckCircle2 className="text-brand-gold flex-shrink-0" size={22} data-id="element-53" />
                  <span className="font-inter font-medium text-[14px] md:text-lg text-brand-navy" data-id="element-54">
                    {item}
                  </span>
                </div>)}
            </div>

            {/* Direct Contact Info */}
            <div className="border-t border-brand-gold/30 pt-8" data-id="element-55">
              <h3 className="font-montserrat font-bold text-brand-navy text-sm tracking-[3px] uppercase mb-5" data-id="element-56">
                {t('contact.info')}
              </h3>
              <ul className="space-y-3" data-id="element-57">
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-58">
                  <Phone size={18} className="text-brand-gold" data-id="element-59" />
                  <a href="tel:7866603720" className="font-inter font-medium hover:text-brand-gold transition-colors" data-id="element-60">
                    (786) 660-3720
                  </a>
                </li>
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-61">
                  <Phone size={18} className="text-brand-gold" data-id="element-62" />
                  <a href="tel:7865602192" className="font-inter font-medium hover:text-brand-gold transition-colors" data-id="element-63">
                    (786) 560-2192
                  </a>
                  <span className="text-xs text-gray-500 italic" data-id="element-64">
                    {t('footer.backup')}
                  </span>
                </li>
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-65">
                  <Mail size={18} className="text-brand-gold" data-id="element-66" />
                  <a href="mailto:twomopgirlsco@gmail.com" className="font-inter font-medium hover:text-brand-gold transition-colors break-all" data-id="element-67">
                    twomopgirlsco@gmail.com
                  </a>
                </li>
                <li className="flex items-center gap-3 text-brand-navy" data-id="element-68">
                  <MapPin size={18} className="text-brand-gold" data-id="element-69" />
                  <span className="font-inter font-medium" data-id="element-70">
                    Miami and Broward Area
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Right Side - Form */}
          <div className="bg-white rounded-[20px] shadow-[0_12px_40px_rgba(27,43,94,0.10)] border border-brand-gold/25 py-6 px-4 md:p-10" data-id="element-71">
            <form className="space-y-3 md:space-y-5" onSubmit={handleSubmit} data-id="element-72">
              <div data-id="element-73">
                <input id="name" type="text" value={name} onChange={e => setName(e.target.value)} placeholder={t('contact.f.name')} className="w-full h-[54px] md:h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[8px] md:rounded-[10px] font-inter text-[16px] focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all" required data-id="element-74" />
              </div>

              <div data-id="element-75">
                <input id="phone" type="tel" value={phone} onChange={e => setPhone(e.target.value)} placeholder={t('contact.f.phone')} className="w-full h-[54px] md:h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[8px] md:rounded-[10px] font-inter text-[16px] focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all" required data-id="element-76" />
              </div>

              <div data-id="element-77">
                <select id="service" value={service} onChange={e => setService(e.target.value)} className="w-full h-[54px] md:h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[8px] md:rounded-[10px] font-inter text-[16px] text-gray-600 focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all bg-white" required data-id="element-78">
                  <option value="" disabled data-id="element-79">
                    {t('contact.f.service')}
                  </option>
                  <option value={t('contact.f.s1')} data-id="element-80">{t('contact.f.s1')}</option>
                  <option value={t('contact.f.s2')} data-id="element-81">{t('contact.f.s2')}</option>
                  <option value={t('contact.f.s3')} data-id="element-82">{t('contact.f.s3')}</option>
                  <option value={t('contact.f.s4')} data-id="element-83">{t('contact.f.s4')}</option>
                  <option value={t('contact.f.s5')} data-id="element-84">{t('contact.f.s5')}</option>
                  <option value={t('contact.f.s6')} data-id="element-85">{t('contact.f.s6')}</option>
                </select>
              </div>

              <div data-id="element-86">
                <input id="date" type="text" value={date} onChange={e => setDate(e.target.value)} placeholder={t('contact.f.dateMobile')} className="w-full h-[54px] md:h-[52px] px-4 border-[1.5px] border-brand-gold/30 rounded-[8px] md:rounded-[10px] font-inter text-[16px] text-brand-navy placeholder:text-gray-400 focus:outline-none focus:border-brand-gold focus:ring-[3px] focus:ring-brand-gold/15 transition-all" required data-id="element-87" />
              </div>

              <button type="submit" className="w-full h-[56px] bg-brand-navy hover:bg-brand-gold hover:text-brand-navy hover:scale-[1.02] transition-all duration-300 text-white font-montserrat font-extrabold text-[16px] rounded-[8px] md:rounded-[12px] mt-3 md:mt-2" data-id="element-88">
                {t('contact.submit')}
              </button>

              <div className="flex items-center justify-center gap-2 mt-4 text-gray-500 text-sm" data-id="element-89">
                <Lock size={14} data-id="element-90" />
                <span data-id="element-91">{t('contact.privacy')}</span>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>;
};